export type ClientEnv = {
  NEXT_PUBLIC_API_BASE_URL?: string;
  NEXT_PUBLIC_DEV_EPISODE_LIMIT?: string;
  NEXT_PUBLIC_TURNSTILE_SITE_KEY?: string;
  NEXT_PUBLIC_TURNSTILE_SITE_KEY_DEV?: string;
};

declare global {
  interface Window {
    __APP_ENV__?: ClientEnv;
  }
  // eslint-disable-next-line no-var
  var __APP_ENV__: ClientEnv | undefined;
}

const DEFAULT_API_BASE_URL = "https://api.podwisegpt.com";

const readGlobalEnv = (): ClientEnv => {
  if (typeof window !== "undefined" && window.__APP_ENV__) {
    return window.__APP_ENV__;
  }

  if (typeof globalThis !== "undefined" && globalThis.__APP_ENV__) {
    return globalThis.__APP_ENV__;
  }

  if (typeof process !== "undefined" && typeof process.env === "object") {
    return {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
      NEXT_PUBLIC_DEV_EPISODE_LIMIT: process.env.NEXT_PUBLIC_DEV_EPISODE_LIMIT,
      NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
      NEXT_PUBLIC_TURNSTILE_SITE_KEY_DEV: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY_DEV,
    };
  }

  return {};
};

const rawEnv = readGlobalEnv();

export const API_BASE_URL = rawEnv.NEXT_PUBLIC_API_BASE_URL ?? DEFAULT_API_BASE_URL;

export const DEV_EPISODE_LIMIT = (() => {
  const limit = rawEnv.NEXT_PUBLIC_DEV_EPISODE_LIMIT;
  if (!limit) return undefined;
  const parsed = Number.parseInt(limit, 10);
  return Number.isFinite(parsed) ? parsed : undefined;
})();

export const isDev = process.env.NODE_ENV !== "production";

// Use dev key in development, production key otherwise
export const TURNSTILE_SITE_KEY = isDev 
  ? (rawEnv.NEXT_PUBLIC_TURNSTILE_SITE_KEY_DEV ?? rawEnv.NEXT_PUBLIC_TURNSTILE_SITE_KEY ?? '3x00000000000000000000FF')
  : (rawEnv.NEXT_PUBLIC_TURNSTILE_SITE_KEY ?? '1x00000000000000000000AA');
